import type { TimelineRecord, TimelineRecordPayload } from './TimelineRecord'

// A counter rather than crypto.randomUUID, because core also runs on
// Hermes, where there is no global `crypto` — Expo installs no polyfill for
// it. The id never leaves memory, so it needs no randomness: it is only
// ever matched against other records in the same timeline, and nothing
// persists or serialises one.
//
// A single counter cannot repeat within a runtime, since JavaScript is
// single-threaded and this is the only place a timeline record id is
// assigned. The prefix covers the two cases where it could: a second copy
// of this module in another bundle, and a module re-evaluation in dev,
// which would otherwise restart the count while earlier records are still
// held in a memo.
const RUN = Math.random().toString(36).slice(2, 8)
let lastId = 0

const nextId = (): string => `${RUN}-${++lastId}`

// questId was a getter on the class. Nothing mutates a record after it is
// built, so reading it once here is equivalent.
const createTimelineRecord = (
  payload: TimelineRecordPayload
): TimelineRecord => ({
  id: nextId(),
  type: payload.type ?? 'general',
  year: payload.year,
  value: payload.value,
  description: payload.description ?? null,
  meta: payload.meta ?? null,
  financialRecord: payload.financialRecord,
  questId: payload.financialRecord?.questId ?? null,
  doubleEntryFromRecordId: payload.doubleEntryFromRecordId ?? null,
  intent: payload.intent ?? 'Prospect',
  // The payload union guarantees one of the two branches: `categoryKey`
  // is set explicitly, or `financialRecord` is set and we read its key.
  categoryKey: payload.categoryKey ?? payload.financialRecord.finCategory.key,
})

export default createTimelineRecord
